import React from 'react';
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import StandardDialog from './StandardDialog';
import { Divider, TextField } from '@material-ui/core';
import Footer from './Footer';
import FormHelperText from '@material-ui/core/FormHelperText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';

const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    },
    root2: {
      backgroundColor: theme.palette.background.paper,
      width: 500,
      position: 'relative',
      minHeight: 300,
    },
    paper: {
      height: 500,
      width: 400,
    },
    control: {
      padding: theme.spacing(2),
    },
    card: {
        height: 500,
        maxWidth: 345,
      },
    card2: {
      height: 100,
      width: 100,
      maxWidth: 345,
    },
      media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
      },
      expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
      },
      expandOpen: {
        transform: 'rotate(180deg)',
      },
      avatar: {
        backgroundColor: 'rgb(0, 160, 175)',
      },
      fab: {
        position: 'absolute',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
      },
      rowIcon: {
        top: '40%'
      },
      titleDark: {
        color: 'rgb(0, 0, 1)',
        fontWeight: 'bold',
        fontSize: '0.79rem'
      },
      numberaccount: {
        color: '#00a0af',
        fontSize: '0.8rem',
        fontWeight: 'bold'
      },
      titleListAccount: {
        color: 'rgb(0, 0, 1)',
        fontSize: '0.69rem'
      },
      titleLight: {
        color: 'rgb(0, 0, 1)',
        fontSize: '0.6rem'
      },
      titleGreenBlackPrimary: {
        color: 'rgb(0, 160, 175)',
        fontWeight: 'bold',
        fontSize: '1.05rem'
      },
      titleGreenBlackSecondary: {
        color: 'rgb(0, 160, 175)',
        fontWeight: 'bold',
        fontSize: '1rem'
      },
      titleselect: {
        fontSize: '70%'
      },
      labelsaldocuenta : {
        color: 'rgb(0, 153, 168)',
        fontWeight: 'bold',
        textAlign : 'center'
      },
      saldoaccout : {
        color: '#000000',
        fontWeight: 'bold',
        // color: '#7bac2e'
      }
  }));
const UserPanelInfoMobile = props => {
    const { user, accountSelected, balances, changeAccount, children, handleAccountChange, dialog } = props
    const classes = useStyles();
    
    return (
        <Grid  item xs={12}  >
                    <List className={classes.root}>
                        <ListItem>
                            <ListItemAvatar>
                            <Avatar aria-label="recipe" className={classes.avatar}>
                                {user.Nombres.charAt(0) }
                            </Avatar>
                            </ListItemAvatar>
                                <ListItemText
                                    primary={
                                        <span className = {classes.titleDark}>{ (user.EsPersonaNatural === true) ? `${user.Nombres} ${user.Apellidos} ` : user.RazonSocial} </span> 
                                    }
                                    secondary={
                                        <span>
                                            <span className = {classes.titleLight}> 
                                                { `${accountSelected.Tipo} - ${accountSelected.Codigo}` }
                                            </span>
                                            <br/>
                                            <span className = {classes.titleLight}> 
                                                { `${user.CorreoElectronico}` }
                                            </span>
                                        </span>
                                    } />
                        </ListItem>
                        {/* <ListItem button  onClick={ handleAccountChange }>
                                                <ListItemAvatar>
                                                <Avatar aria-label="recipe" >
                                                    <CompareArrowsIcon />
                                                </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary="Cambiar Cuenta" secondary="" />
                                            </ListItem> */}
                        </List>

                        <Autocomplete
                                        id="combo-box-demo"
                                        classes={{ input: classes.titleselect }}
                                        value = { accountSelected }
                                        options={balances}
                                        onChange = { (e, nv) => {
                                            changeAccount(nv)
                                        }}
                                        disableClearable
                                        getOptionLabel={ (option) =>  `${option.Tipo} ${option.Codigo}` }
                                        renderOption={(option) => (
                                          <List className={classes.root}>
                                            <ListItem>
                                              <ListItemAvatar>
                                                <Avatar aria-label="recipe" >
                                                  <AccountBalanceWalletIcon />
                                                </Avatar>
                                              </ListItemAvatar>
                                              <ListItemText
                                                secondary={
                                                    <span>
                                                        <span className = {classes.titleListAccount}>{ option.Tipo} </span>
                                                        <span className = {classes.numberaccount}>{ option.Codigo} </span><br />
                                                        <span className = {classes.titleListAccount}> 
                                                          { `Saldo disponible: ` }<b>{`$ ${option.SaldoCuenta}` }</b>
                                                        </span>
                                                    </span>
                                                } 
                                              />
                                            </ListItem>
                                          </List>
                                            
                                        )}
                                        renderInput={(params) => <TextField {...params} label="Seleccione una cuenta"  variant="outlined" fullWidth/>}
                                    />
                                    <br/>
                                    <FormHelperText className = {classes.labelsaldocuenta}>Saldo disponible: <b className = {classes.saldoaccout}>$ {accountSelected.SaldoCuenta}</b></FormHelperText><br/>
                    <Divider/> <br/>
                    { children }
                    <StandardDialog
                        open = {dialog}
                        title = {'Seleccione Cuenta'}
                        handleClose = {handleAccountChange } >
                           <List>
                               {
                                   balances.map(balance => {
                                       return <ListItem key={balance.Codigo} button
                                                onClick = {() => 
                                                {
                                                    handleAccountChange()
                                                    changeAccount(balance)
                                                }}>
                                                  <ListItemText 
                                                    primary={`${balance.Tipo}`}
                                                    secondary={`${balance.Codigo} - $ ${balance.SaldoCuenta}`} />
                                              </ListItem>
                                   })
                               }
                            </List> 
                    </StandardDialog>

                    <Footer />
        </Grid>
    );
};

UserPanelInfoMobile.propTypes = {
    
};

export default UserPanelInfoMobile;